import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

const getStyles = (theme) => ({
  title: {
    userSelect: 'none',
    fontWeight: 700,
    fontFamily: 'Source Sans Pro',
    fontSize: 16,
    color: theme.palette.text.main,
    [theme.breakpoints.up('xs')]: {
      fontSize: 16,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 20,
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: 20,
    },
  },
});

function DarkTitle({ label }) {
  const theme = useTheme();
  const classes = getStyles(theme);
  return <Typography sx={classes.title}>{label}</Typography>;
}

export default DarkTitle;
